<template>
  <div id="header">
    <div class=" width">
      <div class="head">
        <a href="/#/">
          <img src="../../public/images/201910221112561522.png"></a>
      </div>
      <div class="nav">
        <ul>
          <li><a href="/">首页</a></li>
          <li><a href="/#/shiShiXinWen">时事新闻</a></li>
          <li><a href="/#/hangYeZiXun">行业资讯</a></li>
          <li><a href="/#/gaoXinJiShu">高新技术</a></li>
          <li><a href="/#/guoNeiZiXun">国内资讯</a></li>
          <li><a href="/#/quanQiuZiXun">全球资讯</a></li>
          <li><a href="/#/huLianWangJiaNews">互联网+新闻</a></li>
          <li><a href="/#/hangYeHuoDong">行业活动</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header"
}
</script>

<style scoped>

</style>